export enum ClientStatusLabelEnum {
    draft = "Borrador",
    registered = "Registrado"
  }
  